var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandscape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 70,
    r: 70,
    fill: "#1A2062"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4243_104213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.016,
    y: 53.358,
    width: 36.3237,
    height: 59.7827,
    rx: 5.67558,
    transform: "rotate(-30 39.016 53.358)",
    stroke: "#F2F3FF",
    strokeWidth: 3.78372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3428 98.3721C45.3891 96.034 41.4343 92.4314 38.876 87.9264C36.3177 83.4214 35.246 78.1727 35.7687 72.7078M50.3428 98.3721L47.3461 90.4903M50.3428 98.3721L42.7165 99.4984",
    stroke: "#F2F3FF",
    strokeWidth: 3.78372,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0351 41.956C93.9889 44.2941 97.9436 47.8967 100.502 52.4017C103.06 56.9068 104.132 62.1555 103.609 67.6203M89.0351 41.956L92.0318 49.8378M89.0351 41.956L96.6614 40.8297",
    stroke: "#F2F3FF",
    strokeWidth: 3.78372,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4243_104213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(29.999 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandscape);
export default __webpack_public_path__ + "static/media/landscape.a4f31fd010cfb9c8aee624730a85f9d1.svg";
export { ForwardRef as ReactComponent };